var exports = {
  "Sc": "UserArea.module__userAreaInnerWrapper___ZkJUaD",
  "cU": "UserArea.module__userAreaContainer___ZkJUaD",
  "jC": "UserArea.module__popoutContainer___ZkJUaD",
  "oT": "UserArea.module__voiceConnectionWrapper___ZkJUaD",
  "eF": "UserArea.module__userInfo___ZkJUaD",
  "vu": "UserArea.module__active___ZkJUaD",
  "N6": "UserArea.module__userInfoText___ZkJUaD",
  "nT": "UserArea.module__userName___ZkJUaD",
  "ag": "UserArea.module__userStatus___ZkJUaD",
  "uh": "UserArea.module__userStatusLabel___ZkJUaD" + " " + "UserArea.module__userStatus___ZkJUaD",
  "XW": "UserArea.module__userCustomStatus___ZkJUaD" + " " + "UserArea.module__userStatus___ZkJUaD",
  "oM": "UserArea.module__hoverRoll___ZkJUaD",
  "n6": "UserArea.module__defaultState___ZkJUaD",
  "yo": "UserArea.module__hovered___ZkJUaD",
  "EE": "UserArea.module__forceHover___ZkJUaD",
  "gO": "UserArea.module__controlsContainer___ZkJUaD",
  "uH": "UserArea.module__controlButton___ZkJUaD",
  "DY": "UserArea.module__contextMenuHover___ZkJUaD",
  "r9": "UserArea.module__disabled___ZkJUaD",
  "pd": "UserArea.module__controlIcon___ZkJUaD",
  "se": "UserArea.module__controlIconWithDot___ZkJUaD",
  "PP": "UserArea.module__controlDot___ZkJUaD",
};

module.exports = exports;
